<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import axios from "axios";
import moment from "moment";
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId", "excele_aktar", "pdf_aktar", "guncelle"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      dosya: {},
      FormData: {},
      personeller: [],
      gerceklestirme_gorevlisi: [],
      harcama_yetkilisi: [],
      Malzemeler: [],
      MalzemeSayisi: 0,
      FiyatlarArray: [],
      FiyatSayisi: 0,
      toplamyaklasik_maliyet: 0,
      yaklasikmaaliyetgizle: false,
      Fiyatlar: [],
      alim_turu: "",
      ihale_usulu: "",
      hedef: "",
      amac: "",
      donem: "",
      Butcetertibi: "",
      faaliyet: "",
      KurumBilgisi: [],
      ihaleyiyapanmakam: "",

      GununTarihi: moment(String(new Date())).format("DD.MM.YYYY") ,
      raporparametreleri: {
        "fileName": "Sat\\onaybelgesi.frx",
        "fileFormat": "pdf",
        "parameters": [{ "parametreKey": "dosyaid", "parametreVal": "135d9dbb-339a-4e34-8ae3-a1d6c2266bf1" }]
      },
      denemeparam: {
        "fileName": "str\\deneme.frx",
        "fileFormat": "pdf",
        "parameters": [{ "parametreKey": "adi", "parametreVal": "aaaaa" }, { "parametreKey": "soyadi", "parametreVal": "bbbbbbb" }]
      },



      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },
  components: {
    Loader,
    VueQRCodeComponent
  },
  watch: {
    satdosyaId() { },
    guncelle() {
      this.Get();
    }
  },
  methods: {
    Get() {

      let Page = {
        PageNumber: "1",
        PageSize: "9999"
      }

      this.ActionsGet({ "Service": "SatDosya/" + this.satdosyaId, "Page": Page }).then((res) => {
        this.dosya = res.Data
        if (this.dosya.Yaklasikmaliyetgorevliler == null) {
          this.yaklasikmaaliyetgizle = true;
        }
        let birimid = res.Data.Ihaleyiyapanmakam;
        this.ActionsGet({ "Service": "Obirim/" + birimid, "Page": this.Page }).then((res2) => {


          this.ihaleyiyapanmakam = res2.Data.BirimAdi;

        });


        let Alimturu = res.Data.Alimturu;

        this.ActionsSabitGet(1548).then(res => {
          for (var i = 0; i < res.Data.length; i++) {

            if (Alimturu == res.Data[i].Id) {

              this.alim_turu = res.Data[i].Value;
            }

          }
        });

        let ihaleusulu = res.Data.Ihaleturu;

        this.ActionsSabitGet(1552).then(res => {
          for (var i = 0; i < res.Data.length; i++) {

            if (ihaleusulu == res.Data[i].Id) {

              this.ihale_usulu = res.Data[i].Value;
            }

          }
        });
        let amac = res.Data.Amacid;
        this.ActionsFilterGet({ "Service": "StrStratejikAmac", "Page": Page, Filter: "" }).then(res => {
          for (var i = 0; i < res.Data.length; i++) {
            if (amac == res.Data[i].Id) {
              this.amac = res.Data[i].Aciklama;
            }

          }
        });
        let hedef = res.Data.Hedefiid;
        this.ActionsFilterGet({ Service: "StrPerfTablo", Page: Page, Filter: "&AmacId=" + res.Data.Amacid }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {
            if (hedef == res.Data[i].Id) {
              this.hedef = res.Data[i].Adi + " - " + res.Data[i].Hedefi;
            }
          }
        });
        this.ActionsSingleGet({
          Service: "StrPerfDonem",
          Id: this.dosya.Strperfdonem,
        }).then((res) => {
          this.donem = res.Data.Aciklama;

        });
        this.ActionsSingleGet({
          Service: "StrPerfTablolarDetay",
          Id: this.dosya.Faaliyetid,
        }).then((res) => {
          this.faaliyet = res.Data.Gostergesi;

        });



      });

      this.ActionsGet({ "Service": "OKurumSabit", "Page": this.Page }).then((res) => {

        this.KurumBilgisi = res.Data[0];

      });

      this.ActionsFilterGet({ "Service": "SatOnayBelgesi", "Page": this.Page, "Filter": "&Dosyaid=" + this.satdosyaId }).then((res) => {
        if (res.Data.length > 0) {
          this.FormData = res.Data[0];
          this.FormData.Belgetarih = this.$options.filters.formatDate(this.FormData.Belgetarih)
          this.ActionsSingleGet({
            Service: "StrHesapKodlari",
            Id: this.FormData.Butcetertibi,
          }).then((res) => {
            this.Butcetertibi = res.Data.Kod + " " + res.Data.Aciklama;



          });

        }

      });


this.personeller = [];
this.gerceklestirme_gorevlisi = [];
this.harcama_yetkilisi = [];

for (const id of this.FormData.Gorevliler) {
  this.ActionsGet({ Service: `OPersonel/${id}`, Page }).then(res => {
    if (res.Data) {
      this.personeller.push(res.Data);
    }
  });
}

if (this.dosya.Gerceklestirmegorevlisiid) {
  this.ActionsGet({ Service: `OPersonel/${this.dosya.Gerceklestirmegorevlisiid}`, Page }).then(res => {
    if (res.Data) {
      this.gerceklestirme_gorevlisi.push(res.Data);
    }
  });
}

if (this.dosya.Harcamagorevlisiid) {
  this.ActionsGet({ Service: `OPersonel/${this.dosya.Harcamagorevlisiid}`, Page }).then(res => {
    if (res.Data) {
      this.harcama_yetkilisi.push(res.Data);
    }
  });
}






      this.ActionsFilterGet({
        Service: "satdosyamalzeme", Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId + "&OrderBy=Sirano",
      }).then((res) => {
        this.Malzemeler = res.Data;
        this.MalzemeSayisi = res.TotalCount;

        let toplamyakmaliyet = 0;
        for (let i = 0; i < res.TotalCount; i++) {
          let malzemeadedi = res.Data[i].Adet;
          let yakmalzemetutar = 0;


          this.ActionsFilterGet({
            Service: "satdosyafirmafiyat",
            Page: this.Page,
            Filter: "&Dosyamalzemeid=" + res.Data[i].Id + "&Dosyaid=" + this.satdosyaId + "&Fiyatturu=1",
          }).then((resFirmaFiyat) => {


            this.FiyatSayisi = resFirmaFiyat.TotalCount;


            let ortbirimfiyat = 0;
            for (let i = 0; i < resFirmaFiyat.TotalCount; i++) {
              ortbirimfiyat = ortbirimfiyat + resFirmaFiyat.Data[i].Birimfiyat;


              this.Fiyatlar.push(resFirmaFiyat.Data[i]);

            }

            ortbirimfiyat = ortbirimfiyat.toFixed(2) / this.FiyatSayisi;
            yakmalzemetutar = ortbirimfiyat.toFixed(2) * malzemeadedi;



            toplamyakmaliyet = toplamyakmaliyet + yakmalzemetutar;


            this.toplamyaklasik_maliyet = toplamyakmaliyet.toFixed(2);


          });


        }


      });

    },

    fastreport() {


      axios({
        url: 'https://localhost:9001/api/v1/GenericReport',
        method: 'POST',
        responseType: 'blob',
        data: this.raporparametreleri
      })
        .then(response => {
          //YENİ SEKMEDE AÇMAK İÇİN
          console.log(response.Data);
          let blob = new Blob([response.data], { type: 'application/pdf' }),
            url = window.URL.createObjectURL(blob)

          window.open(url)
          /* DİREK İNDİRMEK İÇİN

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
      
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', 'file.pdf');
                        document.body.appendChild(fileLink);
      
                        fileLink.click();
    */

        }).catch(error => error.response.data);

    },




    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.OnayBelgesi;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      var a = document.createElement('a');
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + '.xls';
      a.click();
    },

    Export2Word(element, filename = 'Onay Belgesi') {
      var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html = preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
      });

      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + '.doc' : 'document.doc';

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },



  },
};
</script>
<template>
  <Loader>


    <b-modal id="onaybelgesi" size="xl" scrollable :title="$t('satonaybelgesi.Title')" title-class="font-18" hide-footer>



      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2"
                      @click="ExcelExport('OnayBelgesi', 'OnayBelgesi')">
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{
                        $t("satonaybelgesi.Rapor.ExceleAktar")
                      }}
                    </button>
                    <button type="button" class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="Export2Word('exportContent')">
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      Word'e Aktar
                    </button>




                  </div>
                </div>
              </div>





              <div id="exportContent">



                <div class="table-responsive" ref="OnayBelgesi">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td>
                          <center>
                            <h4><b> {{ $t('satonaybelgesi.Rapor.Title') }}</b></h4>
                          </center>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <table class="table  table-sm table-bordered border-success mb-0"
                            style="border: 1px solid; border-collapse: collapse; width: 97%; margin-left: 10px; margin-right: 5px;">
                            <tbody>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  <strong>{{ $t('satonaybelgesi.Rapor.idareAdi') }}</strong>
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">

                                  T.C. {{ KurumBilgisi.Kurumadi }} {{ ihaleyiyapanmakam }}

                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  <strong>{{ $t('satonaybelgesi.Rapor.belge_tarih_sayi') }}</strong>
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  {{ FormData.Belgetarih | formatDateTable }} / {{ FormData.Belgesayi }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" colspan="2">
                                  <center>
                                    <b>{{ ihaleyiyapanmakam }} MAKAMINA</b>
                                  </center>
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" colspan="2">
                                  <center>
                                    <b>{{ $t('satonaybelgesi.Rapor.alim_bilgi') }}</b>
                                  </center>
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="173">
                                  {{ $t('satonaybelgesi.Rapor.isin_tanimi') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  {{ FormData.Isintanimi }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="173">
                                  {{ $t('satonaybelgesi.Rapor.niteligi') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  {{ alim_turu }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="173">
                                  {{ $t('satonaybelgesi.Rapor.miktari') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  {{ FormData.Isinmiktari }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284"
                                  v-if="!yaklasikmaaliyetgizle">
                                  {{ $t('satonaybelgesi.Rapor.yaklasik_maliyet') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;" width="213"
                                  v-if="!yaklasikmaaliyetgizle">
                                  {{ toplamyaklasik_maliyet | TrParaFormat }} TL
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.odenek') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;" width="213">
                                  {{ FormData.Kullanilabilirodenek | BindeAyiraci }} TL
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.proje_numarasi') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  {{ FormData.Yatirimprojenu }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.butce_tertibi') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  {{ Butcetertibi }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.avans_sarti') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  {{ FormData.Avans }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.ihale_usulu') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">

                                  {{ ihale_usulu }}

                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.strperfdonem') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">

                                  {{ donem }}

                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.amac') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">

                                  {{ amac }}

                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.hedef') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">

                                  {{ hedef }}

                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.faaliyet') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">

                                  {{ faaliyet }}

                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">
                                  {{ $t('satonaybelgesi.Rapor.ilan_sekli') }}
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;" width="478">
                                  {{ FormData.Ilansekliadeti }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">

                                  {{ $t('satonaybelgesi.Rapor.dokuman_bedeli') }}

                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;">
                                  {{ FormData.Dokumanbedel.toFixed(2) | TrParaFormat }} TL
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">

                                  {{ $t('satonaybelgesi.Rapor.fiyat_farki') }}

                                </td>

                                <td style="border: 1px solid; border-collapse: collapse;" v-if="FormData.Fiyatfarkivarmi==null || FormData.Fiyatfarkivarmi==''">
                                  Ödenmeyecektir
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;" v-else>
                                  {{ FormData.Fiyatfarkivarmi }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="284">

                                  {{ $t('satonaybelgesi.Rapor.butcedisi') }}

                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;" v-if="dosya.Butcedisi == true">
                                  Evet
                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;" v-else>
                                  Hayır
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" colspan="2">
                                  <center> <b> {{ $t('satonaybelgesi.Rapor.alim_bilgi_diger') }}</b></center>
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" colspan="2">

                                  <p> {{ $t('satonaybelgesi.Rapor.gorevli_personel') }}</p>


                                  <div v-for="Data in personeller" :key="Data.Id">
                                    {{ Data.Adsoyad }} - {{ Data.Unvanadi }}
                                  </div>
                                  <br>

                                  <p>
                                    {{ FormData.Aciklama }}
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" colspan="2">
                                  <center> <b>{{ $t('satonaybelgesi.Rapor.onay') }}</b></center>
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 1px solid; border-collapse: collapse;" width="50%">
                                  <center>

                                   Yukarıda belirtilen {{ alim_turu }}nı onaylarınıza arz ederim.<br>

                                    {{ Date() | formatDateTable }}
                                    <br>
                                    <br>
                                    <br>
                                    {{ gerceklestirme_gorevlisi[0].Adsoyad }}

                                    <br>
                                    {{ gerceklestirme_gorevlisi[0].Unvanadi }}

                                    <br>
                                  </center>

                                </td>
                                <td style="border: 1px solid; border-collapse: collapse;" width="50%">
                                  <center>
                                    {{ $t('satonaybelgesi.Rapor.uygundur') }}<br>
                                    {{ Date() | formatDateTable }}<br>
                                    {{ $t('satonaybelgesi.Rapor.ihale_yetkilisi') }}
                                    <br>
                                    <br>
                                    <br>

                                    {{ harcama_yetkilisi[0].Adsoyad }}<br>
                                    {{ harcama_yetkilisi[0].Unvanadi }}
                                    <br>

                                  </center>
                                </td>
                              </tr>
                              <tr>
 
                                <td colspan="2" style="border: 1px solid; border-collapse: collapse;" width="100%">
                                  <VueQRCodeComponent  style=" float: right;"
                size="100"
                :text='"İşin Adı: "+FormData.Isintanimi +"  DÜZENLENME TARİHİ:"+GununTarihi+" Oluşturan Kullanıcı:"+UserNameSurName' /> 
              
                                </td>
                              </tr>



                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                 
                </div>

              </div>



            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
